"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagesInfoResolver = void 0;
var objectHelper_1 = require("./helper/objectHelper");
exports.PagesInfoResolver = function (sitePagesModel) {
    var urlFormatModel = sitePagesModel.urlFormatModel, pageJsonFileNames = sitePagesModel.pageJsonFileNames, protectedPageIds = sitePagesModel.protectedPageIds, routersInfo = sitePagesModel.routersInfo;
    var uniquePageIds = objectHelper_1.concatUnique(objectHelper_1.keys(pageJsonFileNames), protectedPageIds);
    return {
        getPagesInfo: function () { return Promise.resolve({
            pageIdsArray: uniquePageIds,
            pageJsonFileNames: pageJsonFileNames,
            routersInfo: routersInfo,
            urlFormatModel: urlFormatModel
        }); }
    };
};
